// extracted by mini-css-extract-plugin
export var icon = "Link-module--icon--RQkGx";
export var icon_left = "Link-module--icon_left--8KQrD";
export var link = "Link-module--link--XTciG";
export var theme_black = "Link-module--theme_black--SkJgn";
export var theme_disabled = "Link-module--theme_disabled--YBrvh";
export var theme_underlined = "Link-module--theme_underlined--HbxZl";
export var theme_uppercase = "Link-module--theme_uppercase--RwOq5";
export var theme_void = "Link-module--theme_void--F5OgM";
export var theme_white = "Link-module--theme_white--6QtSA";